"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyICPSchema = exports.CompanyOverviewSchema = exports.CompanyInformationValidateSchema = exports.CompanyICPValidationSchema = void 0;
const v4_1 = require("zod/v4");
const goal_enum_1 = require("./types/goal.enum");
const zod_1 = require("./zod");
exports.CompanyICPValidationSchema = v4_1.z.object({
    id: v4_1.z.number(),
    company_id: v4_1.z.number(),
    profile: v4_1.z.string(),
    updatedAt: v4_1.z.string(),
    approved: v4_1.z.boolean().nullable(),
});
exports.CompanyInformationValidateSchema = v4_1.z.object({
    name: v4_1.z
        .string()
        .min(3, "Name must be at least 3 characters long.")
        .max(255, "Name must be no longer than 255 characters."),
    description: v4_1.z
        .string()
        .min(80, "Description must be at least 80 characters long.")
        .max(65536, "Description must be no longer than 65536 characters."),
    website: zod_1.ZodHttpURL,
    customers: v4_1.z
        .string()
        .min(10, "Customer field must be at least 10 characters long.")
        .max(65536, "Customer field must be no longer than 65536 characters."),
    goal: v4_1.z.nativeEnum(goal_enum_1.Goal, {
        message: "Please select a valid goal",
    }),
    why: v4_1.z
        .string()
        .min(10, "Why field must be at least 10 characters long.")
        .max(65536, "Why field must be no longer than 65536 characters."),
    current_revenue: v4_1.z
        .number()
        .int("Current revenue must be an integer.")
        .nonnegative("Current revenue must not be negative."),
    suggested_budget: v4_1.z
        .number()
        .int("Suggested budget must be an integer.")
        .nonnegative("Suggested budget must not be negative."),
    tone: v4_1.z
        .string()
        .min(3, "Tone of voice must be at least 3 characters long.")
        .max(65536, "Tone of voice must be no longer than 65536 characters."),
    voice: v4_1.z
        .string()
        .min(3, "Voice must be at least 3 characters long.")
        .max(65536, "Voice must be no longer than 65536 characters."),
    icps: v4_1.z.array(exports.CompanyICPValidationSchema).optional(),
    locations: v4_1.z
        .array(v4_1.z.string().trim().min(2, "Location must be at least 2 characters long."))
        .optional(),
    brand_colors: v4_1.z
        .array(v4_1.z.string().regex(/^#[0-9A-Fa-f]{6}$/, "Must be a valid hex color"))
        .optional(),
});
exports.CompanyOverviewSchema = v4_1.z.object({
    name: v4_1.z.string().describe("Company name"),
    locations: v4_1.z
        .array(v4_1.z.string().describe("Company Location"))
        .describe("Company locations"),
    description: v4_1.z.string().describe("Company description (min 80 tokens)"),
    tone: v4_1.z.string().describe("Company marketing tone"),
    voice: v4_1.z.string().describe("Company marketing voice"),
    logo_url: v4_1.z
        .string()
        .nullable()
        .describe("URL of the company logo if found on the website"),
    brand_colors: v4_1.z
        .array(v4_1.z.string())
        .describe("Brand colors extracted from the website/logo as hex codes (e.g. #FF5733). Include primary, secondary, and accent colors."),
});
exports.CompanyICPSchema = v4_1.z.object({
    profiles: v4_1.z.array(v4_1.z.string()).min(2).max(2),
});
